import { z } from 'zod';

export const schemaEuropaceAcceptOffer = z.object({
    data: z
        .object({
            angebotAnnehmen: z
                .object({
                    jobId: z.string(),
                })
                .optional(),
        })
        .optional(),
    errors: z.array(z.never()).optional(),
});

export type SchemaEuropaceAcceptOffer = z.infer<typeof schemaEuropaceAcceptOffer>;
